import axios from 'axios';

export const tagService = {
  getTags: (params) =>
    axios.get('/tags', { auth: true, params }),

  createTag: (data) =>
    axios.post('/tags', data, { auth: true }),

  updateTag: (id, data) =>
    axios.patch(`/tags/${id}`, data, { auth: true }),

  deleteTag: (id) =>
    axios.delete(`/tags/${id}`, { auth: true }),
};
